export const difficulties = [
  { label: '简单' },
  { label: '中等' },
  { label: '困难' }
]

export const difficultiesArray = [
  {
    text: '简单',
    value: '简单'
  },
  {
    text: '中等',
    value: '中等'
  },
  {
    text: '困难',
    value: '困难'
  }
]

export const problemSet = [
  {
    label: 'leetcode',
    value: 1
  },
  {
    label: 'codeforces',
    value: 2
  },
  {
    label: 'codewars',
    value: 3
  },
  {
    label: 'mine',
    value: 101
  }
]
export const questionBank = [
  {
    label: '全部',
    value: 0
  },
  {
    label: 'leetcode',
    value: 1
  },
  {
    label: 'codeforces',
    value: 2
  },
  {
    label: 'codewars',
    value: 3
  },
  {
    label: 'mine',
    value: 101
  }
]

export const problemSetFilterArray = [
  {
    text: 'leetcode',
    value: 1
  },
  {
    text: 'codeforces',
    value: 2
  },
  {
    text: 'codewars',
    value: 3
  },
  {
    text: 'mine',
    value: 101
  }
]

export const problemType = [
  { label: '贪心' },
  { label: '双指针' },
  { label: '二分查找' },
  { label: '排序' },
  { label: '搜索' },
  { label: '动态规划' },
  { label: '分治' },
  { label: '数学' },
  { label: '位运算' },
  { label: '字符串' },
  { label: '哈希' },
  { label: '数组' },
  { label: '队列' },
  { label: '栈' },
  { label: '链表' },
  { label: '树' },
  { label: '图' },
  { label: '复杂数据结构' }
]

export const problemTypeArray = [
  {
    text: '贪心',
    value: '贪心'
  },
  {
    text: '双指针',
    value: '双指针'
  },
  {
    text: '二分查找',
    value: '二分查找'
  },
  {
    text: '排序',
    value: '排序'
  },
  {
    text: '搜索',
    value: '搜索'
  },
  {
    text: '动态规划',
    value: '动态规划'
  },
  {
    text: '分治',
    value: '分治'
  },
  {
    text: '数学',
    value: '数学'
  },
  {
    text: '位运算',
    value: '位运算'
  },
  {
    text: '字符串',
    value: '字符串'
  },
  {
    text: '哈希',
    value: '哈希'
  },
  {
    text: '数组',
    value: '数组'
  },
  {
    text: '队列',
    value: '队列'
  },
  {
    text: '栈',
    value: '栈'
  },
  {
    text: '链表',
    value: '链表'
  },
  {
    text: '树',
    value: '树'
  },
  {
    text: '图',
    value: '图'
  },
  {
    text: '复杂数据结构',
    value: '复杂数据结构'
  }
]

export const choices = [
  { label: '是' },
  { label: '否' }
]

export const standaloneFilterArray = [
  {
    text: '是',
    value: '是'
  },
  {
    text: '否',
    value: '否'
  }
]

export const studyFilterArray = [
  {
    text: '是',
    value: '是'
  },
  {
    text: '否',
    value: '否'
  }
]

export const statusSet = [
  {
    label: '开始',
    value: 1
  },
  {
    label: '暂停',
    value: 2
  },
  {
    label: '结束',
    value: 3
  }
]

export const statusFilterArray = [
  {
    text: '开始',
    value: 1
  },
  {
    text: '暂停',
    value: 2
  },
  {
    text: '结束',
    value: 3
  }
]

export const importances = [
  {
    label: '一般且容易',
    value: 1
  },
  {
    label: '一般且困难',
    value: 2
  },
  {
    label: '重要且容易',
    value: 3
  },
  {
    label: '重要且困难',
    value: 4
  }
]

export const importanceFilterArray = [
  {
    text: '一般且容易',
    value: 1
  },
  {
    text: '一般且困难',
    value: 2
  },
  {
    text: '重要且容易',
    value: 3
  },
  {
    text: '重要且困难',
    value: 4
  }
]

export const ansLinkFilterArray = [
  {
    text: '是',
    value: '是'
  },
  {
    text: '否',
    value: '否'
  }
]

export const languages = [
  { label: 'C' },
  { label: 'C++' },
  { label: 'Go' },
  { label: 'Java' },
  { label: 'Python3' },
]

export const useTimeFilterArray = [
  {
    text: '用时达标',
    value: true
  },
  {
    text: '用时不达标',
    value: false
  },
]
